/**
 * 숏폼 비디오 볼륨 상태를 세션에서 관리하는 유틸리티
 */

export interface VolumeState {
  muted: boolean;
  volume: number; // 0-1 범위
}

const VOLUME_STORAGE_KEY = 'shorts_video_volume';

/**
 * 기본 볼륨 설정 반환
 */
export const getDefaultVolumeState = (): VolumeState => ({
  muted: true, // 브라우저 autoplay 정책에 맞게 기본 muted
  volume: 1.0
});

/**
 * 세션 스토리지에서 볼륨 상태 가져오기
 */
export const getVolumeState = (): VolumeState => {
  try {
    const stored = sessionStorage.getItem(VOLUME_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        muted: typeof parsed.muted === 'boolean' ? parsed.muted : true,
        volume: typeof parsed.volume === 'number' && parsed.volume >= 0 && parsed.volume <= 1 
          ? parsed.volume 
          : 1.0
      };
    }
  } catch (error) {
    console.warn('볼륨 상태 로드 실패:', error);
  }
  
  return getDefaultVolumeState();
};

/**
 * 세션 스토리지에 볼륨 상태 저장하기
 */
export const setVolumeState = (volumeState: VolumeState): void => {
  try {
    const stateToSave = {
      muted: volumeState.muted,
      volume: Math.max(0, Math.min(1, volumeState.volume)) // 0-1 범위로 제한
    };
    sessionStorage.setItem(VOLUME_STORAGE_KEY, JSON.stringify(stateToSave));
  } catch (error) {
    console.warn('볼륨 상태 저장 실패:', error);
  }
};

/**
 * 볼륨 상태 초기화 (페이지 이탈 시 호출)
 */
export const clearVolumeState = (): void => {
  try {
    sessionStorage.removeItem(VOLUME_STORAGE_KEY);
  } catch (error) {
    console.warn('볼륨 상태 초기화 실패:', error);
  }
};